export const INPUT_WIDTH = {
  FULL: '100%',
  LARGE: '419px',
  MEDIUM: '259px',
  SMALL: '160px',
  DATE: '110px',
  XS: '50px',
};

export const DIALOG_SIDE_PADDINGS = {
  SM: '24px',
  XS: '16px',
};

export const INPUT_BORDER_RADIUS = '4px';
